import {gql, useMutation} from "@apollo/client";

export function useRequestExtraAttempts() {
  return useMutation<{ success: boolean }, { count: number }>(buyMutation);
}

const buyMutation = gql`
  mutation RequestExtraAttemptsMutation($count: Int!) {
    status: requestExtraAttempts(count: $count)
  }
`;
